<!-- 底部 -->
<template>
  <div class="FooterModel">
    <div class="fontMain">
      <!-- 公司信息 -->
      <div class="info scroll-item animate__animated animate__zoomIn">
        <div class="name">
          <div class="iconfont"></div>
          <div class="content">卓信通信股份有限公司</div>
        </div>
        <!-- <div class="iconBox">
          <div
            class="iconItem"
            v-for="(item, index) in iconList"
            :key="index"
            :style="{
              'background-image': 'url(' + $imgUrl + item.iconImg + ')',
            }"
          ></div>
        </div> -->
        <div class="address">
          <div class="iconfont"></div>
          <div class="content">
            <div class="addresFont">{{ address[0] }}</div>
            <div class="addresFont">
              {{ address[1] }} &nbsp; &nbsp; {{ address[2] }}
              <!-- &nbsp;&nbsp; {{address[3]}} -->
            </div>
          </div>
        </div>

        <div class="branchAddress" v-if="branchAddressIs">
          <div class="iconfont"></div>
          <div class="content">
            <div
              class="addresItem"
              v-for="(item, index) in branchAddress"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <!-- 二维码 -->
      <div
        class="QRCode scroll-item animate__animated animate__zoomIn"
        data-wow-delay=".5s"
      ></div>
      <!-- 导航 -->
      <div
        class="navigation scroll-item animate__animated animate__zoomIn"
        data-wow-delay="1s"
      >
        <div class="navModel" v-for="(item, index) in navigatList" :key="index">
          <div class="modelTitle">{{ item.modelName }}</div>
          <div class="modelContent">
            <div
              class="navItem"
              v-for="(navItem, navIndex) in item.children"
              :key="navIndex"
              @click="navClick(navItem)"
            >
              {{ navItem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产权 -->
    <div class="fontFont">
      <div class="fontLeft">
        ©2023 产品版权归{{ recordNo }}所有。保留所有权利。
      </div>
      <div class="fontRight">
        <div class="privacy">隐私政策</div>
        <div class="sever">服务条款</div>
        <div class="cookie">Cookie设置</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, watchEffect, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
let router = useRouter();

const $imgUrl = inject("$imgUrl");

let address = ref([]);
let recordNo = ref([]);
let branchAddress = ref([]);

let webData = JSON.parse(localStorage.getItem("webData"));
address = webData.address.split(",");
recordNo = webData.recordNo;
branchAddress = webData.branchAddress.split("&");

let branchAddressIs = ref(false);

watchEffect(() => {
  // console.log('xxxxxxxxxx', router.currentRoute.value.path == '/about/profile');

  branchAddressIs.value = router.currentRoute.value.path == "/about/profile";
});

import Wow from "wow.js";

onMounted(() => {
  const wow = new Wow({
    // 对所有拥有该class的元素挂载动画
    boxClass: "scroll-item",
    // 需要挂载的动画元素
    animateClass: "animate__animated",
    // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
    offset: 200,
    // 移动设备是否生效
    mobile: true,
    // 是否支持异步
    live: true,
  });
  wow.init();
});

let iconList = ref([
  {
    iconImg: "/icon/weixin.png",
    aLink: "",
  },
  {
    iconImg: "/icon/weibo.png",
    aLink: "",
  },
  {
    iconImg: "/icon/xinlang.png",
    aLink: "",
  },
  {
    iconImg: "/icon/dou.png",
    aLink: "",
  },
  {
    iconImg: "/icon/zhi.png",
    aLink: "",
  },
]);

let navigatList = ref([
  {
    modelName: "公司介绍",
    children: [
      {
        name: "关于卓信",
        aLink: "/about",
      },
      {
        name: "公司简介",
        aLink: "/about/profile",
      },
      {
        name: "新闻资讯",
        aLink: "/news",
      },
      {
        name: "联系我们",
        aLink: "/contact",
      },
    ],
  },
  {
    modelName: "核心业务",
    children: [
      {
        name: "通信工程",
        aLink: "/business/commun",
      },
      {
        name: "DICT",
        aLink: "/business/DICT",
      },
      {
        name: "城市物联网",
        aLink: "/business/Internetthing",
      },
      {
        name: "智慧光纤分配管理系统",
        aLink: "/business/opticalfib",
      },
      {
        name: "无线通信产品",
        aLink: "/business/wireless",
      },
    ],
  },
  {
    modelName: "服务案例",
    children: [
      {
        name: "智慧园区/社区",
        aLink: "/employ/park",
      },
      {
        name: "智慧医疗",
        aLink: "/employ/treat",
      },
      {
        name: "智慧校园",
        aLink: "/employ/campus",
      },
      {
        name: "智慧消防",
        aLink: "/employ/firefig",
      },
      {
        name: "智慧水务",
        aLink: "/employ/wateraff",
      },
      {
        name: "市政工程",
        aLink: "/employ/engineer",
      },
      {
        name: "室内分布",
        aLink: "/employ/distribu",
      },
      {
        name: "宽带接入",
        aLink: "/employ/broadband",
      },
      {
        name: "传输预覆盖",
        aLink: "/employ/cover",
      },
      {
        name: "智慧多功能杆",
        aLink: "/employ/funRod",
      },
      {
        name: "其他案例",
        aLink: "/employ/other",
      },
    ],
  },
]);

let navClick = (val) => {
  router.push(val.aLink);
};
</script>

<style lang="scss" scoped>
.FooterModel {
  width: 60rem;
  margin-left: calc(50% - 30rem);
  margin-top: 8rem;
  padding-bottom: 1rem;

  .fontMain {
    border-bottom: 1px solid rgba(201, 205, 212, 1);
    display: flex;
    padding-bottom: 1rem;

    .info {
      flex: 1;
      margin-top: 10px;

      .name {
        display: flex;
        height: 1.2rem;
        line-height: 1.2rem;
        .iconfont {
          height: 1.2rem;
          width: 1.2rem;
          background-image: url("http://121.28.81.118:8102/jeecg-boot/officialImage/20240315/icon/name.png");
          background-size: 100% 100%;
        }

        .content {
          font-size: 1rem;
          font-weight: 700;
          margin-left: 1rem;
        }
      }

      .iconBox {
        margin-top: 1rem;
        display: flex;
        .iconItem {
          width: 0.8rem;
          height: 0.8rem;
          background-size: 100% 100%;
          margin-right: 0.6rem;
          cursor: pointer;
        }
      }

      .address {
        margin-top: 1rem;
        // height: 2rem;
        display: flex;
        .iconfont {
          height: 1.2rem;
          width: 1.2rem;
          background-image: url("http://121.28.81.118:8102/jeecg-boot/officialImage/20240315/icon/address.png");
          background-size: 100% 100%;
          margin-top: 0.5rem;
        }
        .content {
          margin-left: 0.5rem;
          font-size: 0.6rem;
          line-height: 1.2rem;
        }
      }
      .branchAddress {
        margin-top: 1rem;
        // height: 2rem;
        display: flex;
        .iconfont {
          height: 1.2rem;
          width: 1.2rem;
          background-image: url("http://121.28.81.118:8102/jeecg-boot/officialImage/20240315/icon/address.png");
          background-size: 100% 100%;
          margin-top: 0.4rem;
        }
        .content {
          margin-left: 0.5rem;
          font-size: 0.6rem;
          line-height: 1rem;
          .addresItem {
            padding: 0.2rem 0;
          }
        }
      }
    }

    .QRCode {
      width: 7rem;
      height: 7rem;
      background-image: url("http://121.28.81.118:8102/jeecg-boot/officialImage/20240315/QRCode.png");
      background-size: 100% 100%;
    }

    .navigation {
      margin-top: 10px;
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .navModel {
        // border: 1px solid red;
        width: 6rem;

        .modelTitle {
          font-size: 0.8rem;
          font-weight: 700;
        }

        .modelContent {
          margin-top: 1.5rem;
          font-size: 0.6rem;

          .navItem {
            margin-top: 1rem;
            width: 4rem;
            cursor: pointer;
          }
        }
      }
    }
  }

  .fontFont {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 2rem;

    .fontRight {
      display: flex;

      div {
        margin-left: 2rem;
        cursor: pointer;
      }
    }
  }
}
</style>